import React from 'react';
import { Container } from "../../components/Container/Container";
import LogIn from '../../components/LogIn/LogIn'
import {
    ContainerCatalogStyled
} from "./style";

const Auth = () => (
    <ContainerCatalogStyled style={{ paddingTop: "100px" }}>
        <Container>
            <LogIn />
        </Container>
    </ContainerCatalogStyled>
);

export default Auth;
